import { PulseLoader } from 'react-spinners'

const LoadingTextSwap = ({ pulseColor = "white", isLoading, children }) => {
  return (
    <div className='position-relative d-flex justify-content-center align-items-center' style={{minWidth: "40px"}} >
      <div className={`position-absolute d-flex align-items-center ${isLoading ? "" : "invisible"}`}>
        <PulseLoader color={pulseColor} size={10} />
      </div>
      <div className={`d-flex justify-content-center align-items-center ${isLoading ? "invisible" : ""}`}>
        {children}
      </div>
    </div>
  )
}

export default LoadingTextSwap